module.exports = __webpack_public_path__ + "img/injectionsteps_step9.e0585bd2.png";